import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { customerDiscount } from "../constants/customer";

export const addCustomerDiscount = async (bodyData) => {
  try {
    const res = await api.add_customer_discount(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
}

export const getCustomerDiscountList = async (dispatch, customerID, pageNum, filters) => {
  try {
    const res = await api.customer_discount_list(customerID, pageNum, filters);
    dispatch({ type: customerDiscount, payload: res.data });
  } catch (error) {
    dispatch({ type: customerDiscount, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

export const getCustomerDiscountById = async (customerID, discountID) => {
  try {
    const res = await api.customer_discount_by_id(customerID, discountID);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}

export const editCustomerDiscount = async (customerID, bodyData) => {
  try {
    const res = await api.edit_customer_discount(customerID, bodyData);
    return res.data;
  }
  catch (error) {
    return error?.response?.data || error;
  }
}

export const deleteCustomerDiscount = async (customerID, discountID) => {
  try {
    const res = await api.delete_customer_discount(customerID, discountID);
    return res.data;
  }
  catch (error) {
    return error?.response?.data || error;
  }
}